export enum AuthenticationProviderType {
	GOOGLE = 'Google',
	FACEBOOK = 'Facebook',
	LINKEDIN = 'LinkedIn',
	DIRECT = 'Direct',
}
